import {
  AddIcon,
  CopyIcon,
  DeleteIcon,
  RepeatIcon,
  SettingsIcon
} from "@chakra-ui/icons";
import {
  Box,
  Button,
  Center,
  Flex,
  Grid,
  Text,
  Tooltip
} from "@chakra-ui/react";
import {
  CustomTableColor,
  CustomTableColorColumn
} from "components/dynamic-table/color-table";
import { IconButtonWithLoading } from "components/mailing-components/mailing-table/icon-button-with-loading";
import {
  ModalCreateCampanhaWhatsApp,
  openModalCreateCampanhaWhatsapp
} from "./modal-campanha-whatsapp";
import { useApplicationContext } from "contexts/ApplicationContext";
import { CampanhaWhatsAppListProps } from "../utils";
import { usePromiseData } from "hooks/use-promise-data";
import { CampanhaWhatsAppEndpoints } from "./modal-campanha-whatsapp/utils";
import {
  ModalSessoesWhatsApp,
  openModalSessoesWhatsApp
} from "./modal-sessoes-whatsapp";
import api from "api/api";
import { Toast } from "components/toast";
import { HamburguerIcon } from "components/vectors/humburger-icon";
import {
  ModalDadosDaCampanhaWhatsApp,
  openModalDadosDaCampanhaWhatsApp
} from "./modal-dados-da-campanha-whats-app";
import { PlayIcon } from "components/vectors/play-icon";
import { PauseIcon } from "components/vectors/pause-icon";
import { openModalConfirm } from "components/modal-confirm-new";
import { messageTypeOptions } from "./modal-campanha-whatsapp/steps/steps";
import { InputField } from "components/input-field";
import { useEffect, useState } from "react";
import { ProgressBar } from "components/progress-bar";
import { InfoIcon } from "components/vectors/info-icon";

// const getIcon = (name: string) => {
//   const extension = (name.split(".").pop() || "").toLowerCase();
//   if (extension === "pdf") return <PDFIcon height="16px" width="16px" />;
//   if (extension === "csv") return <CSVIcon height="16px" width="16px" />;
//   if (extension === "xlsx" || extension === "xls")
//     return <ExelIcon height="16px" width="16px" />;
//   if (extension === "txt") return <TextFileIcon height="16px" width="16px" />;
//   if (extension === "json") return <JSONFileIcon height="16px" width="16px" />;
//   if (["jpg", "jpeg", "png", "gif", "bmp", "svg"].includes(extension))
//     return <IMGIcon height="16px" width="16px" />;
//   if (["mp4", "avi", "mov", "wmv", "mkv", "flv", "webm"].includes(extension))
//     return <FileFormatIcon label="VID" height="16px" width="16px" />;
//   if (extension === "docx" || extension === "doc")
//     return <DOCXIcon height="16px" width="16px" />;
//   return <GenericFileIcon height="16px" width="16px" />;
// };

export function CampanhasWhatsAppNova() {
  const { user } = useApplicationContext();
  const {
    result: campanhas = { data: [], count: 0 },
    isLoading,
    onUpdate,
    currentPage,
    setPage
  } = usePromiseData(CampanhaWhatsAppEndpoints.getCampanhasWhatsApp(user));
  const [link, setLink] = useState("");
  const [loadingLink, setLoadingLink] = useState(false);

  const getLink = async () => {
    setLoadingLink(true);
    try {
      const { data } = await api.get("/customers/url-fone");
      setLink(data.url);
    } catch (error) {
    } finally {
      setLoadingLink(false);
    }
  };

  useEffect(() => {
    getLink();
  }, []);

  const columns: CustomTableColorColumn<CampanhaWhatsAppListProps>[] = [
    {
      name: "Nome",
      render: (row) => row.name
    },
    {
      name: <Center w="100%">Data Criação</Center>,
      render: (row) => (
        <Center w="100%">
          {row.createdAt
            ? new Date(row.createdAt).toLocaleString("pt-BR")
            : "-"}
        </Center>
      )
    },
    {
      name: <Center w="100%">Qtd. Contatos</Center>,
      render: (row) => <Center w="100%">{row.qtdContatos}</Center>
    },
    {
      name: "Enviados",
      render: (row) => {
        if (isNaN(row.qtdSent) || isNaN(row.qtdPending))
          return "0/0 telefone(s)";

        const total = row.qtdSent + row.qtdPending;
        let progress = total === 0 ? 100 : (row.qtdSent / total) * 100;
        const paused = row.paused;

        const finished = progress === 100;

        let isPipelineRunning =
          row.origem === "MAILING" && row.pipelineFinished !== true;

        const variant = finished
          ? isPipelineRunning
            ? "waiting"
            : "complete"
          : paused
            ? "paused"
            : "active";

        const label = finished ? (
          isPipelineRunning ? (
            <Flex alignItems="center" gap="8px">
              <Text>Aguardando mailing</Text>
              <Tooltip
                label="O sistema enviou todos os contatos recebidos até agora (100% do lote atual), mas a campanha continua ativa aguardando novos contatos do mailing."
                fontSize="xs"
                bg="gray.800"
                color="white"
                borderRadius="md"
                p="8px"
                maxW="256px"
                placement="top"
              >
                <Center display="inline-flex" alignItems="center">
                  <InfoIcon w="16px" h="16px" color="blue.600" cursor="help" />
                </Center>
              </Tooltip>
            </Flex>
          ) : (
            "Concluído"
          )
        ) : paused ? (
          "Pausado"
        ) : (
          "Enviando..."
        );

        return (
          <Box>
            <ProgressBar
              value={progress}
              variant={variant}
              label={label}
              description={`${row.qtdSent}/${total} telefone(s)`}
            />
          </Box>
        );
      }
    },
    {
      name: <Center w="100%">Msg. Saudação</Center>,
      render: (row) => {
        const { enabledMensagemSaudacao, qtdResponseSaudacao } = row;
        if (enabledMensagemSaudacao) {
          if (qtdResponseSaudacao === 0) {
            return <Center w="100%">Nenhuma resposta</Center>;
          } else if (qtdResponseSaudacao === 1) {
            return <Center w="100%">1 resposta</Center>;
          } else {
            return <Center w="100%">{qtdResponseSaudacao} respostas</Center>;
          }
        } else {
          return <Center w="100%">Não habilitada</Center>;
        }
      }
    },
    {
      name: <Center w="100%">Origem</Center>,
      render: (row) => {
        const parsed = new Map([
          ["MAILING", "Mailing"],
          ["MANUAL", "Manual"]
        ]);
        return <Center w="100%">{parsed.get(row.origem || "")}</Center>;
      }
    },
    {
      name: <Center w="100%">Sessões WhatsApp</Center>,
      render: (row, i) => {
        const opacity = 1;
        const verde = (
          <Box
            w="14px"
            h="14px"
            borderRadius="full"
            bg="linear-gradient(to left bottom, #00ff20, #00df45, #00bf54, #009f59, #047f56)"
            mr="4px"
            opacity={opacity}
          />
        );
        const vermelho = (
          <Box
            w="14px"
            h="14px"
            borderRadius="full"
            bg="linear-gradient(to left bottom, #ff4f4f, #e13e3c, #c32e2a, #a61c18, #8a0606)"
            mr="4px"
            opacity={opacity}
          />
        );
        let ativos = row.activeWppSessions || 0;
        let inativos = row.inactiveWppSessions || 0;

        return (
          <Center w="100%">
            <Grid
              templateColumns="14px calc(32px + 16px) 14px 16px"
              gap="6px"
              alignItems="center"
            >
              {verde}
              <Text lineHeight={1}>{ativos}</Text>
              {vermelho}
              <Text lineHeight={1}>{inativos}</Text>
            </Grid>
          </Center>
        );
      }
    },

    {
      name: "Tipo",
      render: (row) => {
        const option = messageTypeOptions().find(
          ({ value }) => value === row.type
        );
        return option ? (
          <Flex align="center">
            {option.icon}
            <Text ml={2}>{option.label}</Text>
          </Flex>
        ) : (
          ""
        );
      }
    },

    {
      name: "Ações",
      render: (row) => {
        return (
          <Flex>
            <IconButtonWithLoading
              tooltipMessage={"Sessões WhatsApp Participantes"}
              aria-label=""
              icon={<SettingsIcon />}
              mr="8px"
              onClick={async () => {
                const campaignCompletedData =
                  await CampanhaWhatsAppEndpoints.getCampaignCompletedData(
                    row.id
                  );
                openModalSessoesWhatsApp({
                  campaignCompletedData,
                  row,
                  onUpdate
                });
              }}
            />
            <IconButtonWithLoading
              tooltipMessage={"Iniciar/Pausar Campanha"}
              aria-label=""
              icon={
                row.paused ? <PlayIcon /> : <PauseIcon color="currentColor" />
              }
              mr="8px"
              onClick={async () => {
                let paused = row.paused;
                if (row.paused) {
                  const data =
                    await CampanhaWhatsAppEndpoints.playCampanhaWhatsApp(
                      row.id
                    );
                  paused = data.paused;
                } else {
                  const data =
                    await CampanhaWhatsAppEndpoints.pauseCampanhaWhatsApp(
                      row.id
                    );
                  paused = data.paused;
                }
                campanhas.data = campanhas.data.map((camp) => {
                  if (camp.id === row.id) {
                    return { ...camp, paused };
                  }
                  return camp;
                });
                onUpdate(campanhas);
              }}
            />
            <IconButtonWithLoading
              tooltipMessage={"Dados da Campanha"}
              aria-label=""
              icon={<HamburguerIcon />}
              mr="8px"
              onClick={async () => {
                const campaignCompletedData =
                  await CampanhaWhatsAppEndpoints.getCampaignCompletedData(
                    row.id
                  );
                openModalDadosDaCampanhaWhatsApp(campaignCompletedData);
              }}
            />
            <IconButtonWithLoading
              tooltipMessage={"Excluir Campanha"}
              aria-label=""
              icon={<DeleteIcon />}
              variant="danger"
              mr="8px"
              onClick={async () => {
                openModalConfirm({
                  message: (
                    <>
                      Deseja excluir a campanha "<b>{row.name}</b>"?
                    </>
                  ),
                  async onConfirm() {
                    await CampanhaWhatsAppEndpoints.deleteCampanhaWhatsApp(
                      row.id
                    );
                    campanhas.data = campanhas.data.filter(
                      (camp) => camp.id !== row.id
                    );
                    onUpdate(campanhas);
                  },
                  title: "Excluir Campanha"
                });
              }}
            />
          </Flex>
        );
      }
    }
  ];

  return (
    <>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        px="10px"
        mb="30px"
      >
        <Text fontSize="25px" fontWeight="bold">
          Campanhas Whatsapp
        </Text>

        <Flex gap="10px" alignItems="flex-end">
          <Box w="320px">
            <Text mb="8px">Link prospecção</Text>
            <Flex>
              <Flex
                border="1px solid var(--chakra-colors-custom-gray)"
                borderRadius="10px 0 0 10px"
                w="100%"
              >
                <InputField
                  value={link}
                  inputContainerProps={{ my: "-1px" }}
                  inputProps={{
                    border: "none !important",
                    isReadOnly: true
                  }}
                />
              </Flex>
              <IconButtonWithLoading
                tooltipMessage="Copiar link"
                aria-label="Copiar link"
                icon={<CopyIcon />}
                h="32px"
                borderRadius="0 10px 10px 0"
                isLoading={loadingLink}
                onClick={async () => {
                  await navigator.clipboard.writeText(link);
                  Toast({
                    title: "Link copiado com sucesso!",
                    status: "info"
                  });
                }}
              />
            </Flex>
          </Box>

          <Button
            leftIcon={<RepeatIcon />}
            onClick={() => onUpdate()}
            isLoading={isLoading}
            loadingText="Atualizando"
          >
            Atualizar
          </Button>
          <Button
            leftIcon={<AddIcon />}
            onClick={() => openModalCreateCampanhaWhatsapp({ onUpdate })}
          >
            Enviar Novo Arquivo
          </Button>
        </Flex>
      </Flex>

      <CustomTableColor
        columns={columns}
        rows={campanhas.data}
        isLoading={isLoading}
        currentPage={currentPage}
        onSetPage={setPage}
        rowsLength={campanhas.count}
        onFirstPage={() => setPage(0)}
      />

      <ModalDadosDaCampanhaWhatsApp />
      <ModalCreateCampanhaWhatsApp onUpdate={onUpdate} />
      <ModalSessoesWhatsApp />
    </>
  );
}
